export default __webpack_public_path__ + "img/titleback-724c63fb.png";